// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#OPFullscreenButton {\n  position: fixed;\n  bottom: 1vh;\n  right: 1vw;\n  opacity: 0.6;\n  transition: opacity 0.3s;\n  pointer-events: all;\n  z-index: 17;\n}\n\n#OPFullscreenButton.transparent {\n  opacity: 0.3;\n}\n\n#OPFullscreenButton.hide {\n  display: none;\n}\n\n#OPFullscreenButton:active {\n  opacity: 1;\n}\n\n#OPFullscreenButton_image {\n  width: max(5vw, 7vh);\n  height: max(5vw, 7vh);\n}\n\n", ""]);
// Exports
module.exports = exports;
